// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3c47978f","977":"596eeaf0"}[chunkId] + ".chunk.js";
};